/**
 * 比較表示モードの値一覧
 *
 * 分析CrossTableのセル下段の表示パターン:
 * - values: 前回の数字（実数）
 * - difference: 増減額（今回 - 前回）
 * - rate: 増減率（今回 / 前回 × 100 - 100）
 */
export const comparisonDisplayModeValues = ['values', 'difference', 'rate'] as const;

/** 比較表示モード（値一覧から導出） */
export type ComparisonDisplayMode = (typeof comparisonDisplayModeValues)[number];

export const DEFAULT_COMPARISON_DISPLAY_MODE: ComparisonDisplayMode = 'values';
